export class TotalMeasure {
  public label: string;

  public constructor(label: string) {
    this.label = label;
  }
}
